import cx from 'classnames'
import React from 'react'
import Media from 'react-media'

import IconList from '@cinch/oxd-components/icon-list/src'
import { Rosette } from '@cinch/oxd-components/icons/src'
import Link, { Appearance, Size } from '@cinch/oxd-components/link/src'
import SVG from '@cinch/oxd-components/svg/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'
import GlobalContext from '@cinch/oxd-utils/context/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './our-commitment.module.css'

interface OurCommitmentProps {
  children?: React.ReactElement
  iconPosition?: 'right' | 'left'
  isSlim?: boolean
  targetBlank?: boolean
}

const HERO_IMG_SRC = `${getEnv(Env.StaticAssetsUrl)}/promise/hero-image.png`
const BULLET_KEYS = ['bullet1', 'bullet2', 'bullet3', 'bullet4']

const OurCommitment: React.FC<OurCommitmentProps> = ({
  children = null,
  iconPosition = 'right',
  isSlim = false,
  targetBlank = false,
}) => (
  <GlobalContext.Consumer>
    {({ ourCommitmentModule }: Cinch.Context) => (
      <div className={cx(styles.ourCommitment, { [styles.ourCommitmentSlim]: isSlim })}>
        <Text element="h3" className={styles.title} type={TextStyles.vehicleTitle}>
          {ourCommitmentModule.title}
        </Text>
        <div
          className={cx(styles.body, {
            [styles.iconLeft]: iconPosition === 'left',
            [styles.bodySlim]: isSlim,
          })}
        >
          <IconList
            bulletText={BULLET_KEYS.map((bullet) => ourCommitmentModule[bullet])}
            hasGradient={true}
            gradientId={'bravo'}
            doesWrap={isSlim}
            className={cx(styles.list, {
              [styles.listRight]: iconPosition === 'left',
            })}
          />
          {children}
        </div>
        <Link
          to={'/our-commitment'}
          size={Size.mini}
          appearance={Appearance.tertiaryButton}
          className={cx(styles.link, { [styles.linkSlim]: isSlim })}
          target={targetBlank ? '_blank' : '_self'}
          rel={targetBlank ? 'noreferrer noopener' : ''}
          external={targetBlank}
        >
          {ourCommitmentModule.buttonCta}
        </Link>
      </div>
    )}
  </GlobalContext.Consumer>
)

const OurCommitmentAbout: React.FC<{ targetBlank?: boolean }> = ({ targetBlank = false }) => (
  <OurCommitment targetBlank={targetBlank}>
    <Media defaultMatches={true} query={tokens.customMedia.s}>
      {(matches) => !!matches && <SVG children={Rosette} className={styles.rosetteIcon} />}
    </Media>
  </OurCommitment>
)

const OurCommitmentManufacturer: React.FC<{ targetBlank?: boolean }> = ({ targetBlank = false }) => (
  <OurCommitment targetBlank={targetBlank} iconPosition="left">
    <img src={HERO_IMG_SRC} className={styles.carImage} alt="" />
  </OurCommitment>
)

const OurCommitmentSlim: React.FC<{ targetBlank?: boolean }> = ({ targetBlank = false }) => (
  <OurCommitment targetBlank={targetBlank} iconPosition="left" isSlim={true}>
    <img src={HERO_IMG_SRC} className={styles.carImageSlim} alt="" />
  </OurCommitment>
)

export { OurCommitmentAbout, OurCommitmentManufacturer, OurCommitmentSlim }
export default OurCommitment
